<script setup lang="ts">
import { useCustomerStore } from '@stores/me/customer'
import { useAssessmentTestStore } from '@stores/assessment-test'

import { LoaderFullScreenDomain } from '@UI/Loaders/LoaderFullScreenDomain'
import SectionAssessmentTestHeader from '@Sections/Assessment/SectionAssessmentTestHeader.vue'
import SectionAssessmentTestFooter from '@Sections/Assessment/SectionAssessmentTestFooter.vue'
import SectionAssessmentTestCompiling from '@Sections/Assessment/SectionAssessmentTestCompiling.vue'

defineOptions({
  name: 'LayoutAssessment',
})

const customerStore = useCustomerStore()
const assessmentStore = useAssessmentTestStore()
</script>

<template>
  <div
    v-if="customerStore.hasData && assessmentStore.hasData && !assessmentStore.isCompiling"
    class="assessment"
  >
    <div class="assessment__header">
      <slot name="header">
        <SectionAssessmentTestHeader />
      </slot>
    </div>
    <div class="assessment__content">
      <slot />
    </div>
    <div class="assessment__footer">
      <slot name="footer">
        <SectionAssessmentTestFooter />
      </slot>
    </div>
  </div>
  <SectionAssessmentTestCompiling
    v-else-if="assessmentStore.isCompiling"
  />
  <LoaderFullScreenDomain v-else />
</template>

<style scoped lang="scss" src="@scss/layouts/assessment.scss" />
